import { Route, Routes, Navigate } from "react-router-dom"
import { ModulesPage } from "../../pages/private-section/modules-page"
import { PrivateSectionLayout } from "../../pages/private-section/private-section-layout/PrivateSectionLayout"
import { LoginPage, AuthSectionLayout } from "../../pages/auth-section"
import { PrivateRoute } from "../private-route"
import { useAppSelector } from "../../hooks/store-hooks"

const RootRedirect = () => {
  const isValid = useAppSelector((state) => state.auth.isValid)
  return isValid ? <Navigate to="/modulos" replace /> : <Navigate to="/authentication/login" replace />
}

export const MainRouter = () => {
  return (
    <>
      <Routes>
        <Route path="" element={<RootRedirect />} />
        
        <Route path="authentication" element={<AuthSectionLayout />}>
          <Route path="login" element={<LoginPage />} />
        </Route>

        <Route path="modulos" element={
          <PrivateRoute>
            <ModulesPage />
          </PrivateRoute>
        } />
        {/* Fallback route */}
        <Route path="*" element={<Navigate to="" replace />} />
      </Routes>
    </>
  )
}